import React, { Fragment } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import img0 from "../../assets/images/logo/Client/Satya.webp";
import img1 from "../../assets/images/logo/Client/Akshay.webp";
import img2 from "../../assets/images/logo/Client/Varun.webp";
import img3 from "../../assets/images/logo/Client/Juned.webp";

const SliderThree = [
  {
    img: img0,
    icon: "icon_15",
    desc: `Always available to answer our queries. Very knowledgeable about the services they provide. Would recommend to anyone !`,
    name: "Satya Prakash",
    desig: "Director - Nirwana Microsystems",
  },
  {
    img: img1,
    icon: "icon_15",
    desc: `Note G Proved to be a professional service provider from the outset. We appreciate their proactive approach and ability to suggest improvements to a prospective solution on both architectural and business levels. we know we can always rely on NOTE G's various competences when our clients require quality software which would facilitate their business success.`,
    name: "Akshay Seth",
    desig: "Founder & Director - Its For You Pvt. Ltd.",
  },
  {
    img: img2,
    icon: "icon_15",
    desc: `The solutions provided by NoteG Technologies have satisfied all project requirements. The capabilities of the new website have saved an incredible amount of money and time. Their team is hardworking and creative, adapting flexibility to changing requirements throughout the project.`,
    name: "Varun Srivastava",
    desig: "Vice President - Prophecis Technologies Pvt. Ltd.",
  },
  {
    img: img3,
    icon: "icon_15",
    desc: `Appreciation to NoteG team for the outstanding job they did for us. The project is just what we wanted, and we were thrilled with the speed your team exercised. We feel privileged to have these guys working for us! Without any hesitation... highly recommended.`,
    name: "Juned Usmani",
    desig: "Director - Trioca Technologies Pvt. Ltd.",
  },
];

const settings3 = {
  dots: true,
  infinite: true,
  fade: true,
  speed: 100,
  autoplay: true,
  autoplaySpeed: 2000,
  slidesToShow: 1,
  slidesToScroll: 1,
};
const TestimonialThree = () => {
  return (
    <Fragment>
      <Slider className="feedback_slider_three" {...settings3}>
        {SliderThree.map((val, i) => (
          <div key={i} className="item">
            <div className="feedback-block-three d-md-flex">
              <div className="img-meta">
                {/* <img src={`images/media/${val.img}.jpg`} alt="" /> */}

                <img src={val.img} alt="clients" width={130} />
              </div>
              <div className="text-wrapper">
                <div className="icon d-flex justify-content-center align-items-center">
                  <img src={`images/icon/${val.icon}.svg`} alt="image" />
                </div>
                <p>{val.desc}</p>
                <div className="name">
                  <h6>{val.name}</h6>
                  <span>{val.desig}</span>
                </div>
                {/* /.name */}
              </div>
              {/* /.text-wrapper */}
            </div>
            {/* /.feedback-block-three */}
          </div>
        ))}
      </Slider>
      {/* /.feedback_slider_three */}
    </Fragment>
  );
};

export default TestimonialThree;
